import React from "react";

const costPhotoProcessComponent = (props) => {
  const { data } = props;
  return (
    <div style={{ marginBottom: "10px" }}>
      <div className="row">
        <div className="col-md-4 col-xs-6 col-lg-4">
          <img src={data.photoLink} width="100%" height="100%" />
        </div>
        <div className="col-md-8 col-md-6 col-lg-8">
          <h6 className={"title " + data.status.class}>{data.status.text}</h6>
          <h6 className="title">{data.costPhoto.name}</h6>
        </div>
      </div>
    </div>
  );
};
export default costPhotoProcessComponent;
